const RETURN_URL_KEY = 'axis_return_url';

/** Allowed internal paths for post-auth redirect (prevents open redirects). */
function isSafeInternalPath(path: string): boolean {
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//')) return false;
  if (path.startsWith('/login')) return false;
  if (path.startsWith('/oauth/callback')) return false;
  return true;
}

export function storeReturnUrl(path: string): void {
  if (!isSafeInternalPath(path)) return;
  sessionStorage.setItem(RETURN_URL_KEY, path);
}

export function consumeReturnUrl(): string | null {
  const stored = sessionStorage.getItem(RETURN_URL_KEY);
  if (!stored || !isSafeInternalPath(stored)) {
    sessionStorage.removeItem(RETURN_URL_KEY);
    return null;
  }
  sessionStorage.removeItem(RETURN_URL_KEY);
  return stored;
}

export function peekReturnUrl(): string | null {
  const stored = sessionStorage.getItem(RETURN_URL_KEY);
  return stored && isSafeInternalPath(stored) ? stored : null;
}

export function buildLoginPath(returnPath: string): string {
  return `/login?redirect=${encodeURIComponent(returnPath)}`;
}

export function getDefaultRouteForRole(role: string | undefined): string {
  const normalized = role?.toLowerCase() || '';
  if (normalized === 'pending') return '/pending-approval';
  if (normalized === 'clinician') return '/ai-triaging';
  return '/queue';
}
